"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLastArrivals = void 0;
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var selectors_1 = require("../redux/selectors");
var useLastArrivals = function () {
    var _a = (0, react_redux_1.useSelector)(selectors_1.lastArrivalsSelector), lastArrivalsList = _a.lastArrivalsList, _b = _a.stateLoad, error = _b.error, isLoading = _b.isLoad;
    var _c = (0, react_redux_1.useSelector)(selectors_1.mediaQuerySelector), isMedium = _c.isMedium, isSmall = _c.isSmall;
    // Мемоизируем количество слайдов
    var slidesPerView = react_1.default.useMemo(function () {
        if (isSmall)
            return 1;
        return isMedium ? 2 : 3;
    }, [isSmall, isMedium]);
    return {
        lastArrivalsList: lastArrivalsList,
        isLoading: isLoading,
        error: error,
        slidesPerView: slidesPerView,
    };
};
exports.useLastArrivals = useLastArrivals;
